import {
  Document,
  HeadingLevel,
  Packer,
  Paragraph,
  ImageRun,
  convertInchesToTwip,
  PageBreak,
  Header,
  Footer,
  TabStopType,
  TabStopPosition,
  TextRun,
  TableCell,
  TableRow,
  Table,
  AlignmentType,
  PageNumber,
  WidthType,
  BorderStyle,
  HorizontalPositionRelativeFrom,
  VerticalPositionRelativeFrom,
  HorizontalPositionAlign,
  VerticalPositionAlign,
  TextWrappingSide,
  TextWrappingType,
} from "docx";
import htmlToDraft from 'html-to-draftjs'
import { editorType } from "../components/creator";
import { EditorState, convertToRaw, ContentState } from 'draft-js'
import { main_logo_template_b64 } from "./constants";
import { baseIqopsAPI } from "../modules/db";

const table_row_color = '999999';

const no_borders = {
  top: {
    styles: BorderStyle.NONE
  },
  bottom: {
    styles: BorderStyle.NONE
  },
  left: {
    styles: BorderStyle.NONE
  },
  right: {
    styles: BorderStyle.NONE
  }
};

function readAsDataURL(blob) {
  return new Promise((resolve, reject) => {
    let fileReader = new FileReader();
    fileReader.onload = function () {
      return resolve({ data: fileReader.result });
    }
    fileReader.readAsDataURL(blob);
  })
}

export const handleCreateWord = async (sops, details) => {

  const { company, coordinator, charge, alternate, template, version, previous } = { ...details }

  const coordinator_name = `${coordinator?.first_name || ""}` + ' ' + `${coordinator?.last_name || ""}`

  const docus = [];

  docus.push(...renderSopsDocs(sops));
  docus.push(...renderHiSops(sops));
  docus.push(...renderHsSops(sops));
  docus.push(...renderCCPSops(sops));

  const blob = await fetch(
    baseIqopsAPI+company?.logo
    // "https://upload.wikimedia.org/wikipedia/commons/a/ab/Logo_TV_2016.png" //use when developing, since the cors are only being sent over qa and prod
  ).then(r => r.blob());

  const streamReader = await readAsDataURL(blob)
  const base64Logo = streamReader?.data

  const doc = new Document({
    styles: {
      default: {
        title: {
          run: {
            size: convertInchesToTwip(0.08),
            bold: true,
            italics: true,
            color: "002f6c",
          },
        },
        heading1: {
          run: {
            size: 28,
            bold: true,
            color: "002f6c",
          },
        },
        heading2: {
          run: {
            size: 24,
            bold: true,
            color: "002f6c",
          },
        },
        listParagraph: {
          run: {
            color: "#FF0000",
          },
        },
      },
      paragraphStyles: [
        {
          id: "main-title",
          name: "Main Title",
          basedOn: "Normal",
          next: "Normal",
          run: {
            color: "002f6c",
            bold: true,
            size: 45
          },
          paragraph: {
            // indent: {
            //     left: convertInchesToTwip(0.5),
            // },
            spacing: {
              line: 276,
            },
          },
        },
        {
          id: "wellSpaced",
          name: "Well Spaced",
          basedOn: "Normal",
          quickFormat: true,
          paragraph: {
            spacing: { line: 276, before: 20 * 72 * 0.1, after: 20 * 72 * 0.05 },
          },
        },
      ],
    },
    numbering: {
      config: [
        {
          reference: "my-crazy-numbering",
          levels: [
            {
              level: 0,
              // format: LevelFormat.LOWER_LETTER,
              text: "%1)",
              // alignment: AlignmentType.LEFT,
            },
          ],
        },
      ],
    },
    sections: [
      {
        children: [
          new Paragraph({
            children: [
              new ImageRun({
                data: Uint8Array.from(atob(main_logo_template_b64), c =>
                  c.charCodeAt(0)
                ),
                transformation: {
                  width: 380,
                  height: 1125
                },
                floating: {
                  horizontalPosition: {
                    offset: 4099500,
                  },
                  verticalPosition: {
                    offset: 0,
                    // offset: 1013400,
                  },
                },
              })
            ]
          }),
          new Paragraph({
            text: "HACCP",
            heading: HeadingLevel.TITLE,
          }),
          new Paragraph({
            text: "Plan",
            heading: HeadingLevel.TITLE,
            break:2,
          }),
          new Paragraph({
            children: [
              new ImageRun({
                data: base64Logo,
                transformation: {
                  width: 250,
                  height: 250,
                },
              }),
            ],
            break: 2,
          }),
          new Paragraph({
            text: `${company?.name}`,
            heading: HeadingLevel.HEADING_1,
          }),
        ]
      },
      {
        headers: {
          default: new Header({
            children: [
              new Paragraph({
                children: [
                  new ImageRun({
                    data: base64Logo,
                    transformation: {
                      width: 50,
                      height: 50,
                    },
                    floating: {
                      horizontalPosition: {
                        relative: HorizontalPositionRelativeFrom.LEFT_MARGIN,
                        align: HorizontalPositionAlign.CENTER,
                      },
                      verticalPosition: {
                        relative: VerticalPositionRelativeFrom.TOP_MARGIN,
                        align: VerticalPositionAlign.CENTER
                      },
                      behindDocument: true
                    },
                    wrap: {
                      type: TextWrappingType.TIGHT,
                      side: TextWrappingSide.LEFT,
                    },
                  }),
                  new TextRun({
                    text: `                                                    ${template?.name}                                        ${company?.address}`,
                    bold: true,
                    break: 1
                  })
                ],
              })
            ],
          }),
        },
        footers: {
          default: new Footer({
            children: [
              new Paragraph({

                children: [
                  new TextRun({
                    text: `Revised: ${version?.revision}                              HACCP plan                          Approved by ${coordinator_name} `
                  }),
                  new TextRun({
                    text: `Previous : ${previous?.revision || ''}`,
                    break: 1,
                  })
                ],
                tabStops: [
                  {
                    type: TabStopType.RIGHT,
                    position: TabStopPosition.MAX,
                  },
                  {
                    type: TabStopType.LEFT,
                    position: 1000,
                  },
                ],
              })
            ],
          }),
        },
        children: [
          new Paragraph({
            text: "Food Safety Management System Modifications Record",
            heading: HeadingLevel.HEADING_1,
            alignment: AlignmentType.CENTER,
          }),
          new Paragraph({
            children: [
              new TextRun({
                text: "Processes:",
                break: 1,
              }),
              new TextRun({
                text: "{Restaurant details_Establishment Details_Process}",
                break: 2,
              }),
              new TextRun({
                text: "{Image/Table}",
                break: 2,
              }),
            ]
          })
        ],
      },
      {
        children: [
          new Paragraph({
            text: "Establishments details",
            heading: HeadingLevel.HEADING_1,
            alignment: AlignmentType.LEFT,
          }),
          new Paragraph({
            children: [
              new TextRun({
                break: 1,
                text: ''
              })
            ]
          }),
          new Table({
            width: {
              size: 100,
              type: WidthType.PERCENTAGE,
            },
            columnWidths: [3400, 4500],
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Establishment Name",
                            bold: true,
                          })
                        ]
                      })],
                    shading: {
                      fill: table_row_color,
                    },
                  }),
                  new TableCell({
                    children: [new Paragraph(`${company?.name}`)],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Address",
                            bold: true,
                          })
                        ]
                      })],
                    shading: {
                      fill: table_row_color,
                    },
                  }),
                  new TableCell({
                    children: [new Paragraph(`${company?.address}`)],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Person-in-Charge",
                            bold: true,
                          })
                        ]
                      })],
                    shading: {
                      fill: table_row_color,
                    },
                  }),
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: `${charge?.first_name || ""} ${charge?.last_name || ""}`,
                          }),
                          new TextRun({
                            text: `${charge?.email || ""}`,
                            break: 1,
                          }),
                          new TextRun({
                            text: `${charge?.phone_number || ""}`,
                            break: 1,
                          }),
                        ]
                      })
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "Designated Alternates",
                            bold: true,
                          })
                        ]
                      })],
                    shading: {
                      fill: table_row_color,
                    },
                  }),
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: `${alternate?.first_name || ""} ${alternate?.last_name || ""}`,
                          }),
                          new TextRun({
                            text: `${alternate?.email || ""}`,
                            break: 1,
                          }),
                          new TextRun({
                            text: `${alternate?.phone_number || ""}`,
                            break: 1,
                          }),
                        ]
                      })
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "HACCP Coordinator",
                            bold: true,
                          })
                        ]
                      })],
                    shading: {
                      fill: table_row_color,
                    },
                  }),
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: `${coordinator_name}`,
                          }),
                          new TextRun({
                            text: `${coordinator?.email || ""}`,
                            break: 1,
                          }),
                          new TextRun({
                            text: `${coordinator?.phone_number || ""}`,
                            break: 1,
                          }),
                        ]
                      })
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: "HACCP Consultant",
                            bold: true,
                          })
                        ]
                      })],
                    shading: {
                      fill: table_row_color,
                    },
                  }),
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: `Benjamin Cote – iQKitchen Inc.`,
                          }),
                          new TextRun({
                            text: `ben@iqkitchen.co`,
                            break: 1,
                          })
                        ]
                      })
                    ],
                  }),
                ],
              }),
            ]
          })
        ]
      },
      {
        properties: {
          page: {
            pageNumbers: {
              start: 1,
            },
          },
        },
        footers: {
          default: new Footer({
            children: [
              new Paragraph({
                tabStops: [{
                  type: TabStopType.RIGHT,
                  position: 6000
                }],
                children: [
                  new TextRun({
                    text: `Revised: ${version?.revision}                                          `
                  }),
                  new TextRun({
                    children: [`Page | `, PageNumber.CURRENT]
                  }),
                  new TextRun({
                    text: `                         Approved by ${coordinator_name}`
                  }),
                  new TextRun({
                    text: `Previous : ${previous?.revision || ''}`,
                    break: 1,
                  })
                ]
              })
            ],
          }),
        },
        children: docus,
      },
    ]
  });

  return doc;
}

const getRawContent = (html = '<p></p>') => {
  const contentBlock = htmlToDraft(html);
  if (contentBlock) {
    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks)
    const editorState = EditorState.createWithContent(contentState)
    return convertToRaw(editorState.getCurrentContent())
  }
  else {
    return {
      blocks: []
    }
  }
}

const renderCCPSops = (sops) => {
  const docus = [];
  if (sops?.ccp?.sops?.length > 0) {
    docus.push(new Paragraph({
      heading: HeadingLevel.HEADING_1,
      text: 'Hazard Analysis inputs'
    }));

    docus.push(new Paragraph({
      children: [
        new TextRun({
          text: '',
          break: 2
        })
      ]
    }))

    sops.ccp.sops.forEach(sop => {
      if (sop.doctype == editorType.ccp) {
        docus.push(
          new Paragraph({
            text: sop.title,
            heading: HeadingLevel.HEADING_2,
            thematicBreak: true
          })
        )
        docus.push(
          new Table({
            width: {
              size: 100,
              type: WidthType.PERCENTAGE,
            },
            columnWidths: [1026, 8000],
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph("Hazards")],
                    shading: {
                      fill: table_row_color,
                    },
                  }),
                  new TableCell({
                    children:
                      getRawContent(sop?.hazards).blocks.map(block => new Paragraph(block.text))
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph("Critical limits")],
                    shading: {
                      fill: table_row_color,
                    },
                  }),
                  new TableCell({
                    children:
                      getRawContent(sop?.cl).blocks.map(block => new Paragraph(block.text))
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [new Paragraph("Monitoring")],
                    shading: {
                      fill: table_row_color,
                    },
                  }),
                  new TableCell({
                    margins: {
                      left: convertInchesToTwip(0.0),
                    },
                    children: [
                      new Table({
                        // width: {
                        //     size: 100,
                        //     type: WidthType.PERCENTAGE,
                        // },
                        columnWidths: [1000, 7000],
                        rows: [
                          new TableRow({
                            children: [
                              new TableCell({
                                children: [new Paragraph("What")],
                                shading: {
                                  fill: table_row_color,
                                },
                                borders: no_borders,
                              }),
                              new TableCell({
                                children:
                                  getRawContent(sop?.monitoring_what).blocks.map(block => new Paragraph(block.text)),
                                borders: no_borders,
                              }),
                            ],
                          }),
                          new TableRow({
                            children: [
                              new TableCell({
                                children: [new Paragraph("How")],
                                shading: {
                                  fill: table_row_color,
                                },
                                borders: no_borders,
                              }),
                              new TableCell({
                                children:
                                  getRawContent(sop?.monitoring_how).blocks.map(block => new Paragraph(block.text)),
                                borders: no_borders,
                              }),
                            ],
                          }),
                          new TableRow({
                            children: [
                              new TableCell({
                                children: [new Paragraph("When")],
                                shading: {
                                  fill: table_row_color,
                                },
                                borders: no_borders,
                              }),
                              new TableCell({
                                children:
                                  getRawContent(sop?.monitoring_when).blocks.map(block => new Paragraph(block.text)),
                                borders: no_borders,
                              }),
                            ],
                          }),
                          new TableRow({
                            children: [
                              new TableCell({
                                children: [new Paragraph("Who")],
                                shading: {
                                  fill: table_row_color,
                                },
                                borders: no_borders,
                              }),
                              new TableCell({
                                children:
                                  getRawContent(sop?.monitoring_who).blocks.map(block => new Paragraph(block.text)),
                                borders: no_borders,
                              }),
                            ],
                          }),
                        ],
                      })
                    ]
                  })
                ]
              }),
              new TableRow({
                children: [
                  new TableCell({
                    shading: {
                      fill: table_row_color,
                    },
                    children: [new Paragraph("Corrective actions")],
                  }),
                  new TableCell({
                    children:
                      getRawContent(sop?.corrective_actions).blocks.map(block => new Paragraph(block.text))
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    shading: {
                      fill: table_row_color,
                    },
                    children: [new Paragraph("Verification")],
                  }),
                  new TableCell({
                    children:
                      getRawContent(sop?.verification).blocks.map(block => new Paragraph(block.text))
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    shading: {
                      fill: table_row_color,
                    },
                    children: [new Paragraph("Records")],
                  }),
                  new TableCell({
                    children:
                      getRawContent(sop?.records).blocks.map(block => new Paragraph(block.text))
                  }),
                ],
              }),
            ]
          })
        )
      }
    });
  }
  return docus;
}

const renderHsSops = (sops) => {
  const docus = [];
  if (sops?.hs?.sops?.length > 0) {
    let rows = [];

    docus.push(new Paragraph({
      heading: HeadingLevel.HEADING_1,
      text: 'Hazard Analysis process step'
    }));

    docus.push(new Paragraph({
      children: [
        new TextRun({
          text: '',
          break: 2
        })
      ]
    }))

    rows.push(
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph("Process Step")],
            shading: {
              fill: table_row_color,
            },
          }),
          new TableCell({
            children: [new Paragraph("Description")],
            shading: {
              fill: table_row_color,
            },
          }),
        ],
      })
    );
    sops.hs.sops.forEach(sop => {
      rows.push(
        new TableRow({
          children: [
            new TableCell({
              children:
                getRawContent(sop?.title).blocks.map(block => new Paragraph(block.text))
            }),
            new TableCell({
              children:
                getRawContent(sop?.description).blocks.map(block => new Paragraph(block.text))
            }),
          ]
        })
      )
    });
    let table = new Table({
      columnWidths: [4513, 4513],
      rows
    });

    docus.push(table)

    docus.push(new Paragraph({
      children: [
        new TextRun({
          text: '',
          break: 2
        })
      ]
    }))

    rows = [];


    rows.push(
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph("Process Step")],
            shading: {
              fill: table_row_color,
            },
          }),
          new TableCell({
            children: [
              new Paragraph("Potential Hazards"),
              new Paragraph("(B) Biological"),
              new Paragraph("(C) Chemical"),
              new Paragraph("(P) Physical")
            ],
            shading: {
              fill: table_row_color,
            },
          }),
          new TableCell({
            children: [new Paragraph("Are These Hazards RLTO ?")],
            shading: {
              fill: table_row_color,
            },
          }),
          new TableCell({
            children: [new Paragraph("Justification")],
            shading: {
              fill: table_row_color,
            },
          }),
          new TableCell({
            children: [new Paragraph("Measures to prevent, eliminate or reduce Hazards")],
            shading: {
              fill: table_row_color,
            },
          }),
          new TableCell({
            children: [new Paragraph("Is this step a CCP?")],
            shading: {
              fill: table_row_color,
            },
          }),
        ],
      })
    );

    sops.hs.sops.forEach(sop => {
      rows.push(
        new TableRow({
          children: [
            new TableCell({
              children:
                getRawContent(sop?.title).blocks.map(block => new Paragraph(block.text)),
              rowSpan: 4,
            })
          ]
        }),
        new TableRow({
          children: [
            new TableCell({
              children:
                getRawContent(sop?.biological_hazard).blocks.map(block => new Paragraph(block.text)),
            }),
            new TableCell({
              children:
                getRawContent(sop?.bh_rlto).blocks.map(block => new Paragraph(block.text)),
            }),
            new TableCell({
              children:
                getRawContent(sop?.bh_justification).blocks.map(block => new Paragraph(block.text)),
            }),
            new TableCell({
              children:
                getRawContent(sop?.measures).blocks.map(block => new Paragraph(block.text)),
              rowSpan: 4
            }),
            new TableCell({
              children:
                getRawContent(sop?.ccp).blocks.map(block => new Paragraph(block.text)),
              rowSpan: 4
            }),
          ]
        }),
        new TableRow({
          children: [
            new TableCell({
              children:
                getRawContent(sop?.chemical_hazard).blocks.map(block => new Paragraph(block.text)),
            }),
            new TableCell({
              children:
                getRawContent(sop?.ch_rlto).blocks.map(block => new Paragraph(block.text)),
            }),
            new TableCell({
              children:
                getRawContent(sop?.ch_justification).blocks.map(block => new Paragraph(block.text)),
            }),
          ]
        }),
        new TableRow({
          children: [
            new TableCell({
              children:
                getRawContent(sop?.physical_hazard).blocks.map(block => new Paragraph(block.text)),
            }),
            new TableCell({
              children:
                getRawContent(sop?.ph_rlto).blocks.map(block => new Paragraph(block.text)),
            }),
            new TableCell({
              children:
                getRawContent(sop?.ph_justification).blocks.map(block => new Paragraph(block.text)),
            }),
          ]
        }),
      )
    });

    table = new Table({
      columnWidths: [1804, 1504, 1504, 1504, 1504, 1000],
      rows
    });

    docus.push(table);

  }
  return docus;
}

const renderHiSops = (sops) => {
  const docus = [];
  if (sops?.hi?.sops?.length > 0) {
    const rows = [];

    docus.push(new Paragraph({
      heading: HeadingLevel.HEADING_1,
      text: 'Hazard Analysis inputs'
    }));

    docus.push(new Paragraph({
      children: [
        new TextRun({
          text: '',
          break: 2
        })
      ]
    }))

    rows.push(
      new TableRow({
        children: [
          new TableCell({
            children: [new Paragraph("Input / Ingredient")],
            shading: {
              fill: table_row_color,
            },
          }),
          new TableCell({
            children: [
              new Paragraph("Potential Hazards"),
              new Paragraph("(B) Biological"),
              new Paragraph("(C) Chemical"),
              new Paragraph("(P) Physical")
            ],
            shading: {
              fill: table_row_color,
            },
          }),
          new TableCell({
            children: [new Paragraph("Measures to prevent, eliminate or reduce Hazards")],
            shading: {
              fill: table_row_color,
            },
          }),
        ],
      })
    );

    sops.hi.sops.forEach(sop => {
      rows.push(
        new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph(sop.title)
              ],
              rowSpan: 4,
            }),
          ]
        }),
        new TableRow({
          children: [
            new TableCell({
              children:
                getRawContent(sop?.biological_hazard).blocks.map(block => new Paragraph(block.text))
            }),
            new TableCell({
              children:
                getRawContent(sop?.bh_measure).blocks.map(block => new Paragraph(block.text))
            }),
          ]
        }),
        new TableRow({
          children: [
            new TableCell({
              children:
                getRawContent(sop?.chemical_hazard).blocks.map(block => new Paragraph(block.text))
            }),
            new TableCell({
              children:
                getRawContent(sop?.ch_measure).blocks.map(block => new Paragraph(block.text))
            }),
          ]
        }),
        new TableRow({
          children: [
            new TableCell({
              children:
                getRawContent(sop?.physical_hazard).blocks.map(block => new Paragraph(block.text))
            }),
            new TableCell({
              children:
                getRawContent(sop?.ph_measure).blocks.map(block => new Paragraph(block.text))
            }),
          ]
        })
      )
    });


    const table = new Table({
      width: {
        size: 100,
        type: WidthType.PERCENTAGE,
      },
      columnWidths: [3008, 3008, 3008],
      rows
    });
    docus.push(table)

  }
  return docus;
}

const renderSopsDocs = (sops) => {

  const docus = [];

  if (sops?.sop?.sops?.length > 0) {

    docus.push(new Paragraph({
      heading: HeadingLevel.HEADING_1,
      text: 'Standard Operating Procedures & Documents'
    }));

    docus.push(new Paragraph({
      children: [
        new TextRun({
          text: '',
          break: 2
        })
      ]
    }))

    sops.sop.sops.forEach(sop => {
      switch (sop.doctype) {
        case editorType.ccp:
          docus.push(
            new Paragraph({
              text: sop.title,
              heading: HeadingLevel.HEADING_2,
              thematicBreak: true
            })
          )
          docus.push(
            new Table({
              rows: [
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph("Hazards")],
                    }),
                    new TableCell({
                      children: [new Paragraph(sop?.hazards)],
                    }),
                  ],
                }),
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph("Critical limits")],
                    }),
                    new TableCell({
                      children: [new Paragraph(sop?.cl)],
                    }),
                  ],
                }),
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph("Corrective actions")],
                    }),
                    new TableCell({
                      children: [new Paragraph(sop?.corrective_actions)],
                    }),
                  ],
                }),
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph("Verification")],
                    }),
                    new TableCell({
                      children: [new Paragraph(sop?.verification)],
                    }),
                  ],
                }),
                new TableRow({
                  children: [
                    new TableCell({
                      children: [new Paragraph("Records")],
                    }),
                    new TableCell({
                      children: [new Paragraph(sop?.records)],
                    }),
                  ],
                }),
              ]
            })
          )
          break;
        case editorType.doc:
          docus.push(
            new Paragraph({
              text: sop.title,
              heading: HeadingLevel.HEADING_2,
              thematicBreak: true
            })
          )

          docus.push(new Paragraph({
            children: [
              new TextRun({
                text: '',
                break: 2
              })
            ]
          }))

          getRawContent(sop.text).blocks.forEach(block => docus.push(new Paragraph(block.text)))
          docus.push(
            new Paragraph({
              text: `Records`,
              heading: HeadingLevel.HEADING_3,
              thematicBreak: true
            })
          )
          getRawContent(sop.records).blocks.forEach(block => docus.push(new Paragraph(block.text)))
          docus.push(new PageBreak())
          break;
        default:
          docus.push(
            new Paragraph({
              text: sop.title,
              heading: HeadingLevel.HEADING_2,
              thematicBreak: true
            })
          )
          docus.push(new Paragraph({
            children: [
              new TextRun({
                text: '',
                break: 2
              })
            ]
          }))
          docus.push(
            new Paragraph({
              text: `PURPOSE AND INTRODUCTION`,
              heading: HeadingLevel.HEADING_3,
            })
          )
          getRawContent(sop.purposeandintroduction).blocks.forEach(block => docus.push(new Paragraph(block.text)))
          docus.push(
            new Paragraph({
              text: `CRITERIA AND INSTRUCTIONS`,
              heading: HeadingLevel.HEADING_3,
            })
          )
          getRawContent(sop.criteriaandinstructions).blocks.forEach(block => docus.push(new Paragraph(block.text)))
          docus.push(
            new Paragraph({
              text: `FREQUENCY`,
              heading: HeadingLevel.HEADING_3,
            })
          )
          getRawContent(sop.frequency).blocks.forEach(block => docus.push(new Paragraph(block.text)))
          docus.push(
            new Paragraph({
              text: `RESPONSIBILITIES`,
              heading: HeadingLevel.HEADING_3,
            })
          )
          getRawContent(sop.responsibilities).blocks.forEach(block => docus.push(new Paragraph(block.text)))

          docus.push(
            new Paragraph({
              text: `MONITORING`,
              heading: HeadingLevel.HEADING_3,
            })
          )
          getRawContent(sop.monitoring).blocks.forEach(block => docus.push(new Paragraph(block.text)))
          docus.push(
            new Paragraph({
              text: `CORRECTIVE ACTIONS`,
              heading: HeadingLevel.HEADING_3,
            })
          )
          getRawContent(sop.correctiveactions).blocks.forEach(block => docus.push(new Paragraph(block.text)))
          docus.push(
            new Paragraph({
              text: `VERIFICATION AND RECORD KEEPING`,
              heading: HeadingLevel.HEADING_3,
            })
          )
          getRawContent(sop.verificationandrecordkeeping).blocks.forEach(block => docus.push(new Paragraph(block.text)))
          docus.push(
            new Paragraph({
              text: `RECORDS`,
              heading: HeadingLevel.HEADING_3,
            })
          )
          getRawContent(sop.records).blocks.forEach(block => docus.push(new Paragraph(block.text)))
          docus.push(new PageBreak())
          break;
      }
    });
  }
  return docus;
}